import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const VALUE = () => {
  return (
    <CardSection id="VALUE" title="VALUE">
      <Paragraph>문자열 값으로 저장된 숫자를 숫자 값으로 변환합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>VALUE(STRING)</Paragraph>
        <Ul>
          <Li>
            <b>STRING</b>은 숫자 값으로 변환하려는 텍스트 문자열로 저장된
            숫자입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>VALUE(`quantity`)</Paragraph>
        <Img src="computeValue" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>STRING</b>은 텍스트 문자열로 저장된 숫자이거나, 텍스트
          문자열로 저장된 숫자를 포함하는 열이거나, 텍스트 문자열로 저장된
          숫자를 반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>
          <b>STRING</b>에 숫자가 아닌 문자가 포함되어 있으면 함수는 오류를
          반환합니다. 인수 내에 단일 마침표(소수점)를 사용하여 실제 숫자를 만들
          수 있습니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
